//------------------------------------------------------------------------------
// BFA10101G 共架申込一覧
//------------------------------------------------------------------------------
import { GridItems } from '@/utils/grid-items';

// 一覧項目
const gridItems = new GridItems()
  .link('orderNo',          120, '申込番号')
  .text('rev',               80, '版数')
  .text('kyogasyaOrderNo',  190, '共架者申込番号')
  .text('kojiKenmei',       190, '工事件名')
  .date('orderTorokuDate',  100, '申込登録日')
  .date('orderDate',        100, '申込日')
  .date('uketukeSinsaDate', 100, '受付審査日')
  .group('工事場所')
    .text('kojibasyoArea',                80, '地区')
    .text('kojibasyoLine',                80, '冠称')
    .text('kojibasyoPole',               100, '代表電柱')
    .text('kojibasyoPrefectures',        100, '都道府県')
    .text('kojibasyoMunicipalities',     190, '市区郡町村')
    .text('kojibasyoOazatusyo',          190, '大字通称')
    .text('kojibasyoAzatyome',           190, '字丁目')
    .text('kojibasyoBirumei',            190, 'ビル名等')
    .end()
  .date('gijyutuKentoHiyoTutiDate',      100, '技術検討回答日')
  .numb('gijyutuKentoHiyo',              100, '技術検討費用')
  .numb('gijyutuKentoKijyoTaisyoHonsu',  100, '机上対象本数')
  .numb('gijyutuKentoGenbaTaisyoHonsu',  100, '現場対象本数')
  .numb('gijyutuKentoTaisyoHonsu',        80, '対象本数')
  .numb('gijyutuKentoTaisyogaiHonsu',     80, '対象外本数')
  .numb('gijyutuKentoKaHonsu',            80, '可本数')
  .numb('gijyutuKentoHiHonsu',            80, '否本数')
  .date('kyogaOrderTorokuDate',          100, '共架本申込日')
  .date('kyogaSyoninDate',               100, '共架承認日')
  .date('kojiStartKaDate',               100, '工事開始可能日')
  .text('sasimodosiRiyu',                190, '差戻理由')
  .date('sasimodosiDate',                100, '差戻日')
  .text('orderStatusKyogasya',           120, '申込ステータス')
;

// エクスポート
export default gridItems;
